import React, { useEffect, useRef, useState } from 'react'
import { AlertOctagon, AlertTriangle, ArrowLeft, ArrowRightCircle, Clipboard, Edit, Eye, File, FilePlus, FileText, Plus, Printer, Repeat, Save, Search, Shield, Slash, Trash2 } from 'react-feather'
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { closeOrderServices, postDiscounts, startCloseOrden, startRegistroDescuentoOrden, startloadOrden } from '../../../app/store/ordenes/thunks';
import { clearStore } from '../../../app/store/ordenes/slice';
import { useDispatch, useSelector } from 'react-redux';
import { ViewEvidencias } from '../orderTracking/modals/ViewEvidencias';
import { Galeria } from '../orderTracking/modals/Galeria';
import { startloadTarifaAlm } from '../../../app/store/catalagos/thunks';
import { AddFacturacion } from '../customers/modals/AddFacturacion';
import { loadCliente } from '../../../app/store/clientes/thunks';
import { startloadFacturacion } from '../../../app/store/facturacion/thunks';
import { SearchFacturacion } from './modals/SearchFacturacion';
import { useNavigate, useParams } from 'react-router-dom';
import { startloadGarantia, startRegistroGarantia } from '../../../app/store/garantias/thunk';
import { CardCobroOrdenes } from './shared/CardCobroOrdenes';
import { CardDataCustomer } from '../../utils/cards/CardDataCustomer';

export const OrderClose = () => {

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    didOpen: (toast) => {
      // toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  const { descuentos, status, tarifaAlm, tipos_pagos } = useSelector(state => state.catalogos);
  const { servicios } = useSelector(state => state.catalogos);
  const { usuario, id_emp } = useSelector(state => state.usuario);
  const { facturacion, facturacion_edit } = useSelector(state => state.facturacion);
  const { orden_edit, indicadores, isLoading, status_ordenes } = useSelector(state => state.ordenes);
  const [Fotografias, setFotografias] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(startloadTarifaAlm());
    // inputRef.current.focus();
  }, [])

  const { register, reset, formState: { errors }, handleSubmit } = useForm({
    defaultValues: {
      textSearch: "",
    }
  });

  const { register: registerCC, trigger: triggerCC, setFocus: setFocusCC, getValues: getValuesCC, setValue: setValueCC, formState: { errors: errorsCC }, handleSubmit: handleSubmitCC, reset: resetCC } = useForm(
    {
      mode: 'all',
      defaultValues: {
        // enciende: 0, cargador_bat: 0, sonido: 0, red: 0, ensamblado: 0, teclado: 0, limpieza: 0, retorno: 0, checklist: 0, solo_rev: 0
      }
    });

  const handledSearch = (data) => {
    reset({});

    let value = data.textSearch.trim();
    if (/^\d+$/.test(value)) {
      value = `HDL-${value}`;
    } else if (/^hdl-\d+$/i.test(value)) {
      value = value.toUpperCase(); // normaliza a mayúsculas
    }
    dispatch(startloadOrden(value))
  }

  const cancel = () => {
    window.location.reload();
  }

  useEffect(() => {
    if (facturacion_edit.length != 0) {
      setValueCC('id_facturacion', facturacion_edit.ID);
      setValueCC('rfc_factruracion', facturacion_edit.RFC);
      setValueCC('razon_soc_facturacion', facturacion_edit.RAZON_SOCIAL);
      setValueCC('regimen_facturacion', facturacion_edit.REGIMEN_FISCAL);
      setValueCC('telefono_facturacion', facturacion_edit.TELEFONO);
      setValueCC('correo_facturacion', facturacion_edit.CORREO);
      setValueCC('direccion_facturacion', facturacion_edit.DIRECCION + ', CP:' + facturacion_edit.COD_POSTAL);
      setValueCC('cp_facturacion', facturacion_edit.COD_POSTAL);
    }

  }, [facturacion_edit])

  const goNewSearch = () => {
    dispatch(clearStore())
  }

  const registerDescuentos = () => {

    let descuento = [];
    let capturante = usuario; let folio = orden_edit[0]?.FOLIO;
    let orden_detail = orden_edit[0]; let servicios = orden_detail.SERVICIOS; let refacciones = orden_edit[0]["REFACCIONES"]; let subtotal_refacciones = 0;
    let diasAlmCobrar = orden_detail.DIAS_ALMACENADO - Number(tarifaAlm.DIAS_GRACIA);
    if (diasAlmCobrar <= 0) diasAlmCobrar = 0;


    let dat = new Date(); let d = dat.getDate(); let m = dat.getMonth() + 1; if (d < 10) d = "0" + d; if (m < 10) m = "0" + m;
    let fechahora = new Date(); let hora = fechahora.getHours(); let minuto = fechahora.getMinutes(); let segundo = fechahora.getSeconds();
    if (minuto < 10) minuto = "0" + minuto; if (segundo < 10) segundo = "0" + segundo;
    let fechaRegistro = dat.getFullYear() + "/" + m + "/" + d; let horaRegistro = `${hora}:${minuto}:${segundo}`;

    // DESCUENTO ALMACENAMIENTO
    let costoAlm = tarifaAlm.COSTO * (diasAlmCobrar);
    let almacenajeDESC = (costoAlm * (Number(document.getElementById('descAlmacen').value) / 100)).toFixed(2);

    let itemAlmacen = {
      "capturo": capturante,
      "fecha": fechaRegistro,
      "hora": horaRegistro,
      "detalle": folio,
      "comentarios": '',
      "monto": almacenajeDESC,
      "aplicado": 1,
    }

    if (almacenajeDESC != '0.00') {
      descuento.push(itemAlmacen);
    }

    // DESCUENTO SERVICIOS REALIZADOS 
    let subtotal_servicios = 0;
    servicios.forEach(item => {

      if (item.AUTORIZO == 1 && item.ESTADO == 1) {
        subtotal_servicios = subtotal_servicios + Number(item.COSTO);
      }
    });
    let serviciosDESC = (subtotal_servicios * (Number(document.getElementById('descServicios').value)) / 100).toFixed(2);

    let itemServicio = {
      "capturo": capturante,
      "fecha": fechaRegistro,
      "hora": horaRegistro,
      "detalle": folio,
      "comentarios": '',
      "monto": serviciosDESC,
      "aplicado": 2,

    }

    if (serviciosDESC != '0.00') {
      descuento.push(itemServicio);
    }

    // DESCUENTO REFACCIONES
    refacciones.forEach(item => {
      if (item.ESTADO == 5) {
        subtotal_refacciones = subtotal_refacciones + Number(item.COSTO_CLIENTE);
      }

    })
    let refaccionesDESC = (subtotal_refacciones * (Number(document.getElementById('descRefacciones').value) / 100)).toFixed(2);

    let itemRefaccion = {
      "capturo": capturante,
      "fecha": fechaRegistro,
      "hora": horaRegistro,
      "detalle": folio,
      "comentarios": '',
      "monto": refaccionesDESC,
      "aplicado": 3,
    }

    if (refaccionesDESC != '0.00') {
      descuento.push(itemRefaccion);
    }

    // console.log(descuento);

    if (descuento.length != 0) {
      dispatch(startRegistroDescuentoOrden(descuento))
    }

  }

  const closeOrden = () => {

    const folio = orden_edit[0]?.FOLIO;
    const capturante = usuario;
    const recoge = document.getElementById('recoge_text').value;

    if (!recoge) {
      Toast.fire({ icon: 'error', title: 'Debe introducir quien recoge el dispositivo' });
      document.getElementById('recoge_text').focus();
      return;
    }

    // Validar facturación
    const factDivVisible = document.getElementById("facturacion_div").style.display === 'block';
    let idFacturacion = getValuesCC('id_facturacion');
    if (idFacturacion == undefined || idFacturacion == "") idFacturacion = 0

    let flagFacturacion = 0;
    if (factDivVisible) {
      flagFacturacion = 1;
    }

    // Totales ya calculados en el hijo
    const { pagos, descuentos, total, totalPagado, faltante, iva, subtotalGravado, cambio } = datosCobro;

    console.log(descuentos);

    // Validar cobro completo

    // console.log(faltante);

    // Descomentar secciones para el guardado
    if (faltante > 0) {
      Toast.fire({ icon: 'error', title: 'Debe realizar el cobro correspondiente para la orden' });
      return;
    }

    const payload = {
      folio: folio,
      idFacturacion: idFacturacion,
      flagFacturacion: flagFacturacion,
      capturo: capturante,
      idEmp: id_emp,
      recoge: recoge,
      total: total,
      iva: (iva).toFixed(2),
      subtotal: (subtotalGravado).toFixed(2),
      pagado: (totalPagado).toFixed(2),
      cambio: (cambio).toFixed(2),
      detailPagos: pagos
    };

    const confirmMsg = flagFacturacion
      ? `Está por cerrar la orden: ${folio}. No se han indicado los datos para realizar la facturacion correspondiente. (Puede ir al menu Facturacion, seccion pendientes a indicarlos, ya que se haya cerrado la orden). ¿Desea continuar?`
      : `Está por cerrar la orden: ${folio}. ¿Desea continuar?`;

    Swal.fire({
      title: 'Atención',
      text: confirmMsg,
      icon: 'warning',
      showCancelButton: true,
      showCancelButton: true, confirmButtonText: 'Si, continuar', cancelButtonText: 'No, cancelar',
      customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-secondary ms-2' }, buttonsStyling: false
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(closeOrderServices(payload));


        if (descuentos.length > 0) {
          dispatch(postDiscounts(payload, descuentos))
        }


      }
    });

  }

  const showDivFacturacion = (e) => {
    document.getElementById("facturacion_div").style.display = "block";
  }

  const HideDivFacturacion = (e) => {
    document.getElementById("facturacion_div").style.display = "none";
    setValueCC('id_facturacion', "");
    setValueCC('rfc_factruracion', "");
    setValueCC('razon_soc_facturacion', "");
    setValueCC('regimen_facturacion', "");
    setValueCC('telefono_facturacion', "");
    setValueCC('correo_facturacion', "");
    setValueCC('direccion_facturacion', "");
    setValueCC('cp_facturacion', "");
  }

  let paramsURL = useParams();

  useEffect(() => {
    if (!paramsURL.folio) {
      // console.log('TODO NORMAL');
    } else {
      // console.log('ejecutar busqueda argumento');
      reset({});
      dispatch(startloadOrden(paramsURL.folio))
    }
  }, [paramsURL])



  const [datosCobro, setDatosCobro] = useState({
    pagos: [],
    descuentos: [],
    total: 0,
    totalPagado: 0,
    cambio: 0,
    faltante: 0,
    iva: 0,
    subtotalGravado: 0
  });

  const handleUpdateCobro = (data) => {
    setDatosCobro(data);
  };


  if (isLoading) {
    return (
      <>
        <div className='div_center'>
          <div className='text-center'>
            <div className="spinner"></div>
          </div>
          <div className='text-center text-left-15'>
            <span className='fw-bold'>Cargando</span>
          </div>
          <div className='text-center text-left-15'>
            <div className="spinner"></div>
          </div>
        </div>
      </>
    )
  }

  if (status_ordenes == 'EN_ESPERA' || status_ordenes == 'ORDENES_NO_ENCONTRADOS') {
    return (
      <>
        <div className="mb-3">
          <h1 className="h4 d-inline align-middle fw-bold">Cierre de Orden de Servicio</h1>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
            <div className="card ">

              <form onSubmit={handleSubmit(handledSearch)}>
                <div className="card-body">
                  <label className="mb-1 fw-bold text-dark">Orden de Servicio:</label>
                  <div className="d-flex">
                    <input className="form-control me-2" type="search" aria-label="Search" autoComplete='off' {...register("textSearch", { required: 'Introduce folio de Orden de Servicio' })}
                    // ref={(e) => {inputRef.current = e;  }} 
                    />
                    <button type='submit' className="btn btn-outline-secondary">
                      <Search size='20' />
                    </button>
                  </div>
                  {
                    errors.textSearch &&
                    <div className='text-left-5 mt-2'>
                      <AlertTriangle size="18" color="#dc3545" />
                      <span className='text-left-10 fw-bold text-danger'><small>{errors.textSearch.message}</small></span>
                    </div>
                  }
                </div>
              </form>
            </div>
          </div>
          <div className='col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-9'>
            <div className="alert alert-light" role="alert">
              <h6 className="fw-bold text-dark h3">Instrucciones para Cerrar  una Orden de Servicio</h6>
              <p className="card-text h4 justify">No es posible dar cierre una Orden de Servicio hasta que la busques, sigue los siguientes pasos...</p>
              <p className="card-text mt-2"><span className='fw-bold'>Paso #1:</span><br /> Introduce el Folio de la Orden de Servicio, estas tienen el prefijo HDL - #####</p>
              <p className="card-text"><span className='fw-bold'>Paso #2:</span><br /> Presiona el Icono de la Lupa para buscar, si es contrada la Orden se cargara la informacion de la misma.</p>
              <p className="card-text"><span className='fw-bold'>Por la dudas:</span><br />
                Si la Orden no es encontrada se te informara a traves de un mensaje y podras realizar una nueva busqueda.
              </p>
              {/* <p className="card-text"></p> */}
            </div>
          </div>
        </div>
      </>
    )
  }



  if (status_ordenes == 'ORDEN_ENCONTRADA') {
    let orden_detail = orden_edit[0];
    let servicios = orden_detail.SERVICIOS;
    let subtotal_servicios = 0;
    let subtotal_refacciones = 0;
    let evidencias = orden_edit[0]["EVIDENCIAS"];
    let CONTROLCC = orden_edit[0].CONTROL_CALIDAD;
    let refacciones = orden_edit[0]["REFACCIONES"];
    let anticipos = orden_edit[0]["ANTICIPOS"];
    let total_anticipos = 0;


    servicios.forEach(item => {
      // console.log(item.ID);
      if (item.AUTORIZO == 1 && item.ESTADO == 1) {
        subtotal_servicios = subtotal_servicios + Number(item.COSTO);
      }
    });

    refacciones.forEach(item => {
      if (item.ESTADO == 5) {
        subtotal_refacciones = subtotal_refacciones + Number(item.COSTO_CLIENTE);
      }

    })

    let subtotal = subtotal_refacciones + subtotal_servicios;
    let iva_servicios = (subtotal_servicios / 1.16) * 0.16;
    let acumuladoServicios = subtotal_servicios - iva_servicios;
    let iva_refacciones = (subtotal_refacciones / 1.16) * 0.16;
    let acumuladoRefacciones = subtotal_refacciones - iva_refacciones;


    const launchreport = (e) => {
      console.log(orden_edit.folio);
      window.open(`./assets/reports/ordenEntrega.html?folio=${e}`, '_blank');
    }

    if (orden_detail.ESTADO < 7) {
      return (
        <div className='row'>
          <div className='col-12'>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item btn-link" onClick={goNewSearch}><ArrowLeft size='20' /> Atras</li>
                <li className="breadcrumb-item active" aria-current="page">Detalles de la Orden</li>
              </ol>
            </nav>
          </div>

          <div className='col-10 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
            <div className="alert alert-light" role="alert">
              <div className='row'>
                <div className='col-1'>
                  <AlertOctagon size='20' />
                </div>
                <div className='col-10 text-start'>
                  <h4>Esta Orden de Servicio no puede ser cerrada hasta que se haya acompletado todo el proceso de seguimiento de Orden...</h4>
                  <button type="button" className="btn btn-outline-dark" onClick={goNewSearch}>
                    Ok. Entiendo, vamos atras....
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }

    if (orden_detail.ESTADO == 7) {
      // console.log();
      return (
        <>
          <ViewEvidencias /> <Galeria /> <AddFacturacion /> <SearchFacturacion opc={0} />
          <div className="mb-3">
            <h1 className="h4 d-inline align-middle fw-bold">Cierre de Orden de Servicio</h1>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
              <div className="card ">
                <div className="card-body">
                  <label className="mb-1 fw-bold text-dark">Orden de Servicio:</label>
                  <div className="d-flex">
                    <input className="form-control me-2" type="search" aria-label="Search" disabled value={orden_detail.FOLIO} />
                    <button className="btn btn-outline-secondary" onClick={goNewSearch}>
                      <Repeat size='20' />
                    </button>
                  </div>
                </div>
              </div>

              <CardDataCustomer data={orden_detail} variant={1} />
              <div className='card'>
                <div className='card-body'>
                  <div className="row mt-1">
                    <div className="col-12">
                      <h5 className="fw-bold me-2 border-0">Equipo </h5>
                      <hr className="my-0" />
                    </div>
                    <div className="col-12 mt-1">
                      <div className="mb-2">
                        <label className="form-label">Equipo:</label>
                        <input type="text" className="form-control" value={orden_detail.EQUIPO} disabled />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-2">
                        <label className="form-label">S.N:</label>
                        <input type="text" className="form-control" value={orden_detail.NO_SERIE} disabled />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-2">
                        <label className="form-label">Sistema Operativo:</label>
                        <input type="text" className="form-control" value={orden_detail.SIS_OP} disabled />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-1">
                        <label className="form-label">Cargador: <span> {orden_detail.CARGADOR == 1 ? <> Si </> : <> No </>} </span>
                        </label>
                        <input type="text" className="form-control" value={orden_detail.CARGADOR_SN} disabled />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="mb-1">
                        <label className="form-label">Bateria: <span> {orden_detail.BATERIA == 1 ? <> Si </> : <> No </>}</span></label>
                        <input type="text" className="form-control" value={orden_detail.BATERIA_SN} disabled />
                      </div>
                    </div>

                    <div className="col-12 mt-2">
                      <button type="button" className="btn btn-outline-dark border-0 w-100" data-bs-toggle="modal" data-bs-target="#galery">Ver fotografias</button>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-9">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title fw-bold text-dark mb-2">Detalles de trabajo realizado</h5>
                  <hr className="my-0" />
                  {/* dIAGNOSTICO */}
                  <div className="row mt-2">
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-2">
                      <label className="form-label fw-bold">Descripción de la falla(s):</label>
                      <textarea className="form-control" rows="6" disabled defaultValue={orden_detail.DESCRIPCION_FALLA}></textarea>
                    </div>
                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-2">
                      <label className="form-label fw-bold">Diagnostico:</label>
                      <textarea className="form-control" rows="6" disabled defaultValue={orden_detail.DIAGNOSTICO}></textarea>
                    </div>
                  </div>

                  {/* sERVICIOS */}
                  <h5 className="card-title fw-bold text-dark mb-2 mt-3">Servicios realizados </h5>
                  <div className="row mb-3">
                    <div className="table-responsive mt-1 table-scrollbar-6">
                      <table className="table table-sm table-striped table-hover">
                        <thead>
                          <tr>
                            <th scope="col" className='th-sticky'>#</th>
                            <th scope="col" className='th-sticky'>SERVICIO</th>
                            <th scope="col" className="text-center th-sticky">AUTORIZADO</th>
                            <th scope="col" className="text-center th-sticky">REALIZADO</th>
                            <th scope="col" className="text-center th-sticky">EVIDENCIAS</th>
                            <th scope="col" className="text-end th-sticky">COSTO</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            servicios.map((item, index) => (
                              <tr key={index} className={item.AUTORIZO != 1 ? 'table-warning' : ''}>
                                <td>{index + 1}</td>
                                <td>{item.NOMBRE}</td>
                                <td className="text-center">
                                  {
                                    item.AUTORIZO == 1 ? <>
                                      <img src="./assets/images/indicators/check.png" width="28" height="28" /></> : <><img src="./assets/images/indicators/close.png" width="28" height="28" /></>
                                  }
                                </td>
                                <td className="text-center" >
                                  {
                                    item.ESTADO == 1 ? <>
                                      <img src="./assets/images/indicators/check.png" width="28" height="28" /></> : <><img src="./assets/images/indicators/close.png" width="28" height="28" /></>
                                  }
                                </td>
                                <td className="text-center">
                                  {
                                    evidencias.length != 0 ? <><img src="./assets/images/indicators/image.png" width="28" height="28" data-bs-toggle="modal" data-bs-target="#viewEvidencias" /></> : <><img src="./assets/images/indicators/clock.png" width="28" height="28" /></>
                                  }
                                </td>
                                <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO)}</td>

                              </tr>
                            ))
                          }

                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan={5} className="text-end fw-bold">Subtotal SIN IVA:</td>
                            <td className="fw-bold text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(acumuladoServicios)}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>

                  {/* Refacciones Instaladas */}
                  <h5 className="card-title fw-bold text-dark mb-1 mt-4">Refacciones Instaladas </h5>
                  <div className="row mb-3">
                    <div className="table-responsive mt-1 table-scrollbar-6">
                      <table className="table table-sm table-striped table-hover">
                        <thead>
                          <tr>
                            <th scope="col" className='th-sticky'>#</th>
                            <th scope="col" className='th-sticky'>REFACCIÓN</th>
                            <th scope="col" className="text-center th-sticky">ESTADO</th>
                            <th scope="col" className="text-center th-sticky">EVIDENCIAS</th>
                            <th scope="col" className="text-end th-sticky">COSTO ($)</th>
                            <th scope="col" className="text-end th-sticky">C. CLIENTE. ($)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            refacciones.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.REFACCION}</td>

                                <td className="text-center">
                                  {item.ESTADO == 0 ? <> <span className="status-btn pending-btn"> Solicitada </span>  </> : <> </>}
                                  {item.ESTADO == 1 ? <> <span className="status-btn revision-btn"> Aprobada </span>  </> : <> </>}
                                  {item.ESTADO == 2 ? <> <span className="status-btn progress-btn"> Comprada, en espera </span>  </> : <> </>}
                                  {item.ESTADO == 3 ? <> <span className="status-btn tests-btn"> Llego </span>  </> : <> </>}
                                  {item.ESTADO == 4 ? <> <span className="status-btn vacaciones-btn"> Disponible </span>  </> : <> </>}
                                  {item.ESTADO == 5 ? <> <span className="status-btn complete-btn"> Instalada </span>  </> : <> </>}
                                  {item.ESTADO == 6 ? <> <span className="status-btn pending-btn"> Rechazo Cliente </span>  </> : <> </>}
                                </td>
                                <td className="text-center">
                                  {
                                    evidencias.length != 0 ? <><img src="./assets/images/indicators/image.png" width="28" height="28" data-bs-toggle="modal" data-bs-target="#viewEvidencias" /></> : <><img src="./assets/images/indicators/clock.png" width="28" height="28" /></>
                                  }
                                </td>

                                <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO_HDL)}</td>
                                <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO_CLIENTE)}</td>
                              </tr>
                            ))
                          }

                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan={5} className="text-end fw-bold">Subtotal SIN IVA:</td>
                            <td className="fw-bold text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(acumuladoRefacciones)}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>

                  <div className='row'>
                    <div className='col-12'>
                      <div className="text-end">
                        <h5 className="">Subtotal de Servicios y Refacciones: <span
                          className="fw-bold">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subtotal)}</span> </h5>
                      </div>
                    </div>
                  </div>

                  {/* Entrega de Equipo */}
                  <h5 className="card-title fw-bold text-dark mb-2">Entrega de Equipo</h5>
                  <hr className="my-0" />
                  <div className="row mt-2">
                    <div className="col-12">
                      <div className="mb-2">
                        <label className="form-label">Quien recoge:</label>
                        <input type="text" className="form-control " id='recoge_text' aria-label="First name" />
                      </div>
                      <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="requierofacura" id="inlineRadio1" value="0" defaultChecked onClick={e => HideDivFacturacion(e)} />
                        <label className="form-check-label" >No, requiero factura</label>
                      </div>
                      <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="requierofacura" id="inlineRadio2" value="1" onClick={e => showDivFacturacion(e)} />
                        <label className="form-check-label" >Si, requiero factura</label>
                      </div>
                    </div>
                  </div>
                  {/* FaCTURACION */}
                  <div id="facturacion_div" className="row mt-4" style={{ display: "none" }}>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                      <h5 className="fw-bold  border-0">Datos de facturación </h5>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 text-start mb-1">
                      <button type="button" className="btn btn-outline-dark border-0" data-bs-toggle="modal" data-bs-target="#newFacturacion">
                        <Plus size='20' />
                      </button>
                      <button type="button" className="btn btn-outline-dark border-0" data-bs-toggle="modal" data-bs-target="#searchFacturacion">
                        <Search size='20' />
                      </button>
                    </div>
                    <hr className="my-0" />
                    <div className="row mt-2">

                      <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">

                        <input type="hidden" className="form-control" disabled  {...registerCC("id_facturacion")} />
                        <div className="mb-1">
                          <label className="form-label">RFC:</label>
                          <input type="text" className="form-control" disabled {...registerCC("rfc_factruracion")} />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">

                        <div className="mb-1">
                          <label className="form-label">Razon Social:</label>
                          <input type="text" className="form-control"  {...registerCC("razon_soc_facturacion")} disabled />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                        <div className="mb-1">
                          <label className="form-label">Regimen:</label>
                          <input type="text" className="form-control"  {...registerCC("regimen_facturacion")} disabled />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                        <div className="mb-1">
                          <label className="form-label">Telefono:</label>
                          <input type="text" className="form-control"  {...registerCC("telefono_facturacion")} disabled />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                        <div className="mb-1">
                          <label className="form-label">Correo Electronico:</label>
                          <input type="text" className="form-control" {...registerCC("correo_facturacion")} disabled />
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3"></div>
                      <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9">
                        <div className="mb-1">
                          <label className="form-label">Dirección:</label>
                          <textarea className="form-control" rows="4" {...registerCC("direccion_facturacion")} disabled></textarea>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                        <div className="mb-1">
                          <label className="form-label">CP:</label>
                          <input type="text" className="form-control" {...registerCC("cp_facturacion")} disabled />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* COBRO DE CUENTA */}
                  <CardCobroOrdenes
                    storage={orden_detail?.DIAS_ALMACENADO}
                    listServices={orden_detail?.SERVICIOS}
                    listParts={orden_detail?.REFACCIONES}
                    avancedPayments={orden_detail?.ANTICIPOS}
                    listDiscount={descuentos}
                    listPaymentMethods={tipos_pagos}
                    costStorage={tarifaAlm}
                    onUpdate={handleUpdateCobro}
                  />


                  <div className="card-body text-end">
                    <button type="button" className="btn btn-outline-danger mt-2" onClick={cancel}>
                      <Slash size='20' /> Cancelar
                    </button>
                    <button type="submit" className="btn btn-outline-primary mt-2 ms-3" onClick={closeOrden}>
                      <Save size='20' /> Guardar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )
    }


    let dat = new Date();
    let d = dat.getDate(); let m = dat.getMonth() + 1; if (d < 10) d = "0" + d; if (m < 10) m = "0" + m; let fechaHO = dat.getFullYear() + "-" + m + "-" + d;
    let fechaH = new Date(fechaHO).getTime();

    let fechaR = new Date(orden_detail.FECHA_CERRADA_C).getTime();
    let diferenciadias = (fechaH - fechaR) / (1000 * 60 * 60 * 24);

    if (orden_detail.ESTADO == 8 || orden_detail.ESTADO == 9) {
      return (
        <div className='row'>
          <div className='col-12'>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item btn-link" onClick={goNewSearch}><ArrowLeft size='20' /> Atras</li>
                <li className="breadcrumb-item active" aria-current="page">Detalles de la Orden</li>
              </ol>
            </nav>
          </div>

          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
            <div className="alert alert-light" role="alert">
              <div className='row'>
                <div className='col-1'>
                  <AlertOctagon size='20' />
                </div>
                <div className='col-10 text-start'>
                  <span className='fw-bold '>La Orden de Servicio con el Folio: {orden_detail.FOLIO}, ya fue
                    {
                      orden_detail.ESTADO == 8 ? <> Concluida por {orden_detail.EMPLEADO_CIERRA} el dia {orden_detail.FECHA_CERRADA} a las {orden_detail.HORA_CERRADA} </> : <></>
                    }
                    {
                      orden_detail.ESTADO == 9 ? <> Cancelada por peticion del Cliente {orden_detail.NOMBRE} el dia {orden_detail.FECHA_CERRADA} a las {orden_detail.HORA_CERRADA}  </> : <></>
                    }

                  </span><br />
                  <button type="button" className="btn btn-outline-dark mt-2 me-3" onClick={goNewSearch}>
                    Ok. Entiendo, vamos atras....
                  </button>
                  <button type="button" className="btn btn-outline-dark mt-2" onClick={() => launchreport(orden_detail.FOLIO)}>
                    <Printer size='20' /> Imprimir reporte
                  </button>

                  {
                    orden_detail.ESTADO == 8 ?
                      <>
                        {
                          diferenciadias <= tarifaAlm.DIAS_GARANTIA ?
                            <>
                              <button type="button" className="btn btn-outline-primary mt-2 me-3">
                                <Shield size='20' /> Solicitud de Garantia
                              </button>
                            </>
                            : <>
                              <p className='mt-2 fw-bold'> No es posible solicitar la garantia porque ya caduco para esta orden</p>
                            </>
                        }
                      </>
                      : <><p className='mt-2 fw-bold'> No es posible solicitar la garantia porque la orden fue cancelada a peticion del cliente</p></>
                  }
                </div>
              </div>
            </div>
          </div>
          {/* <div className='col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-3 text-end'>
          </div> */}

          <div className='col-12'>
            <ViewEvidencias /> <Galeria /> <AddFacturacion /> <SearchFacturacion />
            <div className="row">
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                <div className="card ">
                  <div className="card-body">
                    <label className="mb-1 fw-bold text-dark">Orden de Servicio:</label>
                    <div className="d-flex">
                      <input className="form-control me-2" type="search" aria-label="Search" disabled value={orden_detail.FOLIO} />

                    </div>
                  </div>
                  <hr className="my-0" />
                  <div className="card-body">
                    <div className="row mb-1">
                      <div className="col-12">
                        <h5 className="fw-bold me-2 border-0">Datos del Cliente </h5>
                      </div>
                    </div>


                  </div>
                  <CardDataCustomer data={orden_detail} variant={1} />
                  <div className='card'>
                    <div className='card-body'>
                      <div className="row mt-1">
                        <div className="col-12">
                          <h5 className="fw-bold me-2 border-0">Equipo </h5>
                          <hr className="my-0" />
                        </div>
                        <div className="col-12 mt-1">
                          <div className="mb-2">
                            <label className="form-label">Equipo:</label>
                            <input type="text" className="form-control" value={orden_detail.EQUIPO} disabled />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mb-2">
                            <label className="form-label">S.N:</label>
                            <input type="text" className="form-control" value={orden_detail.NO_SERIE} disabled />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mb-2">
                            <label className="form-label">Sistema Operativo:</label>
                            <input type="text" className="form-control" value={orden_detail.SIS_OP} disabled />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="mb-1">
                            <label className="form-label">Cargador: <span> {orden_detail.CARGADOR == 1 ? <> Si </> : <> No </>} </span>
                            </label>
                            <input type="text" className="form-control" value={orden_detail.CARGADOR_SN} disabled />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="mb-1">
                            <label className="form-label">Bateria: <span> {orden_detail.BATERIA == 1 ? <> Si </> : <> No </>}</span></label>
                            <input type="text" className="form-control" value={orden_detail.BATERIA_SN} disabled />
                          </div>
                        </div>

                        <div className="col-12 mt-2">
                          <button type="button" className="btn btn-outline-dark border-0 w-100" data-bs-toggle="modal" data-bs-target="#galery">Ver fotografias</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-9">
                <div className="card">

                  <div className="card-body">

                    <h5 className="card-title fw-bold text-dark mb-2">Detalles de trabajo realizado</h5>
                    <hr className="my-0" />
                    {/* dIAGNOSTICO */}
                    <div className="row mt-2">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-2">
                        <label className="form-label fw-bold">Descripción de la falla(s):</label>
                        <textarea className="form-control" rows="6" disabled defaultValue={orden_detail.DESCRIPCION_FALLA}></textarea>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-2">
                        <label className="form-label fw-bold">Diagnostico:</label>
                        <textarea className="form-control" rows="6" disabled defaultValue={orden_detail.DIAGNOSTICO}></textarea>
                      </div>
                    </div>

                    {/* sERVICIOS */}
                    <h5 className="card-title fw-bold text-dark mb-2 mt-3">Servicios realizados </h5>
                    <div className="row mb-3">
                      <div className="table-responsive mt-1 table-scrollbar-6">
                        <table className="table table-sm table-striped table-hover">
                          <thead>
                            <tr>
                              <th scope="col" className='th-sticky'>#</th>
                              <th scope="col" className='th-sticky'>SERVICIO</th>
                              <th scope="col" className="text-center th-sticky">AUTORIZADO</th>
                              <th scope="col" className="text-center th-sticky">REALIZADO</th>
                              <th scope="col" className="text-center th-sticky">EVIDENCIAS</th>
                              <th scope="col" className="text-end th-sticky">COSTO</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              servicios.map((item, index) => (
                                <tr key={index} className={item.AUTORIZO != 1 ? 'table-warning' : ''}>
                                  <td>{index + 1}</td>
                                  <td>{item.NOMBRE}</td>
                                  <td className="text-center">
                                    {
                                      item.AUTORIZO == 1 ? <>
                                        <img src="./assets/images/indicators/check.png" width="28" height="28" /></> : <><img src="./assets/images/indicators/close.png" width="28" height="28" /></>
                                    }
                                  </td>
                                  <td className="text-center" >
                                    {
                                      item.ESTADO == 1 ? <>
                                        <img src="./assets/images/indicators/check.png" width="28" height="28" /></> : <><img src="./assets/images/indicators/close.png" width="28" height="28" /></>
                                    }
                                  </td>
                                  <td className="text-center">
                                    {
                                      evidencias.length != 0 ? <><img src="./assets/images/indicators/image.png" width="28" height="28" data-bs-toggle="modal" data-bs-target="#viewEvidencias" /></> : <><img src="./assets/images/indicators/clock.png" width="28" height="28" /></>
                                    }
                                  </td>
                                  <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO)}</td>

                                </tr>
                              ))
                            }

                          </tbody>
                          <tfoot>
                            <tr>
                              <td colSpan={5} className="text-end fw-bold">Subtotal:</td>
                              <td className="fw-bold text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subtotal_servicios)}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>

                    {/* Refacciones Instaladas */}
                    <h5 className="card-title fw-bold text-dark mb-1 mt-4">Refacciones Instaladas </h5>
                    <div className="row mb-3">
                      <div className="table-responsive mt-1 table-scrollbar-6">
                        <table className="table table-sm table-striped table-hover">
                          <thead>
                            <tr>
                              <th scope="col" className='th-sticky'>#</th>
                              <th scope="col" className='th-sticky'>REFACCIÓN</th>
                              <th scope="col" className="text-center th-sticky">ESTADO</th>
                              <th scope="col" className="text-center th-sticky">EVIDENCIAS</th>
                              <th scope="col" className="text-end th-sticky">COSTO ($)</th>
                              <th scope="col" className="text-end th-sticky">C. CLIENTE. ($)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              refacciones.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.REFACCION}</td>

                                  <td className="text-center">
                                    {item.ESTADO == 0 ? <> <span className="status-btn pending-btn"> Solicitada </span>  </> : <> </>}
                                    {item.ESTADO == 1 ? <> <span className="status-btn revision-btn"> Aprobada </span>  </> : <> </>}
                                    {item.ESTADO == 2 ? <> <span className="status-btn progress-btn"> Comprada, en espera </span>  </> : <> </>}
                                    {item.ESTADO == 3 ? <> <span className="status-btn tests-btn"> Llego </span>  </> : <> </>}
                                    {item.ESTADO == 4 ? <> <span className="status-btn vacaciones-btn"> Disponible </span>  </> : <> </>}
                                    {item.ESTADO == 5 ? <> <span className="status-btn complete-btn"> Instalada </span>  </> : <> </>}
                                    {item.ESTADO == 6 ? <> <span className="status-btn pending-btn"> Rechazo Cliente </span>  </> : <> </>}
                                  </td>
                                  <td className="text-center">
                                    {
                                      evidencias.length != 0 ? <><img src="./assets/images/indicators/image.png" width="28" height="28" data-bs-toggle="modal" data-bs-target="#viewEvidencias" /></> : <><img src="./assets/images/indicators/clock.png" width="28" height="28" /></>
                                    }
                                  </td>

                                  <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO_HDL)}</td>
                                  <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO_CLIENTE)}</td>
                                </tr>
                              ))
                            }

                          </tbody>
                          <tfoot>
                            <tr>
                              <td colSpan={5} className="text-end fw-bold">Subtotal:</td>
                              <td className="fw-bold text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subtotal_refacciones)}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>

                    <div className='row'>
                      <div className='col-12'>
                        <div className="text-end">
                          <h5 className="">Subtotal de Servicios y Refacciones: <span
                            className="fw-bold">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subtotal)}</span> </h5>
                        </div>
                      </div>
                    </div>



                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else {

      let dat = new Date(); let d = dat.getDate(); let m = dat.getMonth() + 1; if (d < 10) d = "0" + d; if (m < 10) m = "0" + m;
      let fechaHoy = dat.getFullYear() + "/" + m + "/" + d;
      let serviciosAplicados = orden_detail.SERVICIOS;
      let sGarantiaAplicable = [];
      serviciosAplicados.forEach(item => {
        if (item.DIAS_GARANTIA > 0) {

          let fechaCierre = new Date(orden_detail.FECHA_CERRADA_C); // Fecha actual
          let garantiaVence = new Date(fechaCierre);
          garantiaVence.setDate(garantiaVence.getDate() + Number(item.DIAS_GARANTIA)); // Sumar 30 días

          let dia = String(garantiaVence.getDate()).padStart(2, '0'); // Obtener día y rellenar con 0 si es necesario
          let mes = String(garantiaVence.getMonth() + 1).padStart(2, '0'); // Mes (se suma 1 porque empieza en 0)
          let anio = garantiaVence.getFullYear(); // Año completo

          let garantiaVenceFormateada = `${dia}/${mes}/${anio}`;
          let garantiaVenceF = `${anio}/${mes}/${dia}`;

          if (fechaHoy <= garantiaVenceF && item.ESTADO == 1 && item.AUTORIZO == 1) {
            sGarantiaAplicable.push(item)
          }
        }
      });

      const goWarranties = (folio) => {
        // console.log(folio);
        dispatch(startloadGarantia(folio))
        navigate('/warranties');
      }

      // Control de Fotografias
      const addFotografia = () => {
        // setEvidencias([]);
        let filesA = document.getElementById("fotografia_up").files;
        // let evidencia = Fotografias.filter(item => item.name == filesA[0].name);
        setFotografias([...Fotografias, ...filesA]);
        Toast.fire({
          icon: 'success',
          title: 'Fotografia del equipo agregada al Listado'
        })
      }

      const removeFotografia = (name) => {
        Toast.fire({
          icon: 'success',
          title: 'Fotografia Eliminada de la lista'
        });
        let arrayANTERIOR = [...Fotografias];
        // console.log(arrayANTERIOR);
        let result = arrayANTERIOR.filter(item => item.name != name);
        setFotografias(result);
      }

      const removeAllFotografias = () => {
        if (Fotografias.length != 0) {
          setFotografias([]);
          Toast.fire({
            icon: 'success',
            title: 'Se ha eliminado la lista de fotografias'
          });
        }
      }

      const startRegisterGarantia = (folio) => {
        if (Fotografias.length == 0) {
          Toast.fire({
            icon: 'error',
            title: 'NO se han agregado Fotografias'
          });
          return;
        }

        dispatch(startRegistroGarantia(folio, id_emp, sGarantiaAplicable, orden_detail.CLIENTE_ID, orden_detail.EQUIPO_ID, Fotografias))
      }

      return (
        <div className='row'>
          <div className='col-12'>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item btn-link" onClick={goNewSearch}><ArrowLeft size='20' /> Atras</li>
                <li className="breadcrumb-item active" aria-current="page">Detalles de la Orden</li>
              </ol>
            </nav>
          </div>

          <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12'>
            <div className="alert alert-light" role="alert">
              <div className='row'>
                <div className='col-1'>
                  <AlertOctagon size='20' />
                </div>
                <div className='col-10 text-start'>
                  <div className='row'>
                    <div className='col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 col-xxl-10'>
                      <span className=' '>La Orden de Servicio con el Folio: {orden_detail.FOLIO}, ya fue
                        {
                          orden_detail.ESTADO == 8 ?
                            <>
                              Concluida por {orden_detail.EMPLEADO_CIERRA} el dia {orden_detail.FECHA_CERRADA} a las {orden_detail.HORA_CERRADA}


                              {
                                (orden_detail.GARANTIA != null || orden_detail.GARANTIA != undefined || orden_detail.GARANTIA > 0) ?
                                  <>

                                    <br />
                                    Esta orden tiene registrado una Solicitud de Garantia con el Folio {orden_detail.GARANTIA}


                                  </> :
                                  <>


                                    {
                                      (sGarantiaAplicable.length != 0) ?
                                        <><br />
                                          Esta orden puede ingresar el equipo a garantia por el/los siguiente(s) Servicio(s):

                                          {
                                            sGarantiaAplicable.map((item, index) => (
                                              <>  <br />
                                                <span key={index}> * - Servicio: {item.NOMBRE} Garantia: {item.DIAS_GARANTIA} - * </span>
                                              </>
                                            ))
                                          }

                                          <div className='row mt-2'>
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                              <h5 className="card-title fw-bold text-dark mb-2">Fotografias del equipo</h5>
                                              <hr className="my-0 mb-3" />
                                              <div className="d-flex">
                                                <label htmlFor="formFile" className="form-label"></label>
                                                <input className="form-control form-control" id="fotografia_up" type="file" accept="image/*" />
                                                <button className="btn btn-outline-primary no border-0 " type="button" onClick={() => addFotografia()}>
                                                  <Plus size='20' />
                                                </button>
                                              </div>

                                              <div className="mt-2 table-responsive table-scrollbar-5">
                                                <table className="table table-sm">
                                                  <thead>
                                                    <tr>
                                                      <th scope="col">#</th>
                                                      <th scope="col">Archivo</th>
                                                      <th scope="col" className="text-center">ACCIONES</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>

                                                    {
                                                      Fotografias.length === 0 ?
                                                        <>
                                                          <tr >
                                                            <td scope="row" colSpan={3} className='text-danger fw-bold'> <AlertTriangle size={20} className='text-danger fw-bold me-2' /> No se han agregado fotografias, de como se ha recibido el equipo</td>
                                                          </tr>
                                                        </> :
                                                        Fotografias.map((item, index) => (
                                                          <tr key={index}>
                                                            <td scope="row">{index + 1}</td>
                                                            <td>{item.name}</td>
                                                            {/* <td className="text-end">{item.COSTO_SERV}</td> */}
                                                            <td className="text-center">
                                                              <button className="btn btn-outline-danger border-0 " type="button" onClick={() => removeFotografia(item.name)}>
                                                                <Trash2 size='20' />
                                                              </button>
                                                            </td>
                                                          </tr>
                                                        ))
                                                    }
                                                  </tbody>
                                                </table>
                                              </div>
                                              <div className="btn-group" role="group" aria-label="Basic outlined example">
                                                <button type="button" className="btn btn-outline-danger mt-1 mb-1 me-4" onClick={removeAllFotografias} >Eliminar todos: ({Fotografias.length})</button>

                                                <button type="button" className="btn btn-outline-primary mt-1 mb-1  " onClick={() => startRegisterGarantia(orden_detail.FOLIO)}>
                                                  <FilePlus size='20' /> Solicitar Garantia
                                                </button>
                                              </div>
                                            </div>
                                          </div>


                                        </> :
                                        <>
                                          <br />
                                          Esta orden NO puede ingresar el equipo a garantia, estas ya vencieron o no cuenta con garantia los servicios realizados.
                                        </>
                                    }
                                  </>
                              }



                            </> : <></>
                        }
                        {
                          orden_detail.ESTADO == 9 ? <> Cancelada por peticion del Cliente {orden_detail.NOMBRE} el dia {orden_detail.FECHA_CERRADA} a las {orden_detail.HORA_CERRADA}  </> : <></>
                        }

                      </span>
                    </div>

                    <div className='col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 '>

                      <button type="button" className="btn btn-outline-dark mt-2 w-100" onClick={() => launchreport(orden_detail.FOLIO)}>
                        <Printer size='20' /> Imprimir reporte
                      </button>

                      {
                        (orden_detail.GARANTIA != null || orden_detail.GARANTIA != undefined || orden_detail.GARANTIA > 0) ?
                          <>
                            <button type="button" className="btn btn-outline-primary mt-2 w-100"
                              onClick={() => goWarranties(orden_detail.GARANTIA)}
                            >
                              <ArrowRightCircle size='20' /> Seguimiento a Garantia
                            </button>
                          </> :
                          <>

                          </>
                      }
                    </div>






                  </div>




                </div>
              </div>
            </div>
          </div>


          {/* Aqui va */}
          <div className='col-12'>
            <ViewEvidencias /> <Galeria />
            <div className="row">
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                <div className="card ">
                  <div className="card-body">
                    <label className="mb-1 fw-bold text-dark">Orden de Servicio:</label>
                    <div className="d-flex">
                      <input className="form-control me-2" type="search" aria-label="Search" disabled value={orden_detail.FOLIO} />

                    </div>
                  </div>
                  <CardDataCustomer data={orden_detail} variant={1} />
                  <div className='card'>
                    <div className='card-body'>
                      <div className="row mt-1">
                        <div className="col-12">
                          <h5 className="fw-bold me-2 border-0">Equipo </h5>
                          <hr className="my-0" />
                        </div>
                        <div className="col-12 mt-1">
                          <div className="mb-2">
                            <label className="form-label">Equipo:</label>
                            <input type="text" className="form-control" value={orden_detail.EQUIPO} disabled />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mb-2">
                            <label className="form-label">S.N:</label>
                            <input type="text" className="form-control" value={orden_detail.NO_SERIE} disabled />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mb-2">
                            <label className="form-label">Sistema Operativo:</label>
                            <input type="text" className="form-control" value={orden_detail.SIS_OP} disabled />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="mb-1">
                            <label className="form-label">Cargador: <span> {orden_detail.CARGADOR == 1 ? <> Si </> : <> No </>} </span>
                            </label>
                            <input type="text" className="form-control" value={orden_detail.CARGADOR_SN} disabled />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="mb-1">
                            <label className="form-label">Bateria: <span> {orden_detail.BATERIA == 1 ? <> Si </> : <> No </>}</span></label>
                            <input type="text" className="form-control" value={orden_detail.BATERIA_SN} disabled />
                          </div>
                        </div>

                        <div className="col-12 mt-2">
                          <button type="button" className="btn btn-outline-dark border-0 w-100" data-bs-toggle="modal" data-bs-target="#galery">Ver fotografias</button>
                        </div>
                      </div>
                    </div>
                  </div>







                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-9">
                <div className="card">

                  <div className="card-body">

                    <h5 className="card-title fw-bold text-dark mb-2">Detalles de trabajo realizado</h5>
                    <hr className="my-0" />
                    {/* dIAGNOSTICO */}
                    <div className="row mt-2">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-2">
                        <label className="form-label fw-bold">Descripción de la falla(s):</label>
                        <textarea className="form-control" rows="6" disabled defaultValue={orden_detail.DESCRIPCION_FALLA}></textarea>
                      </div>
                      <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-2">
                        <label className="form-label fw-bold">Diagnostico:</label>
                        <textarea className="form-control" rows="6" disabled defaultValue={orden_detail.DIAGNOSTICO}></textarea>
                      </div>
                    </div>

                    {/* sERVICIOS */}
                    <h5 className="card-title fw-bold text-dark mb-2 mt-3">Servicios realizados </h5>
                    <div className="row mb-3">
                      <div className="table-responsive mt-1 table-scrollbar-6">
                        <table className="table table-sm table-striped table-hover">
                          <thead>
                            <tr>
                              <th scope="col" className='th-sticky'>#</th>
                              <th scope="col" className='th-sticky'>SERVICIO</th>
                              <th scope="col" className="text-center th-sticky">GARANTIA</th>
                              <th scope="col" className="text-center th-sticky">AUTORIZADO</th>
                              <th scope="col" className="text-center th-sticky">REALIZADO</th>
                              <th scope="col" className="text-center th-sticky">EVIDENCIAS</th>
                              <th scope="col" className="text-end th-sticky">COSTO</th>

                            </tr>
                          </thead>
                          <tbody>
                            {
                              servicios.map((item, index) => (
                                <tr key={index} className={item.AUTORIZO != 1 ? 'table-warning' : ''}>
                                  <td>{index + 1}</td>
                                  <td>{item.NOMBRE}</td>
                                  <td className="text-center">{item.DIAS_GARANTIA} Dia(s) </td>
                                  <td className="text-center">
                                    {
                                      item.AUTORIZO == 1 ? <>
                                        <img src="./assets/images/indicators/check.png" width="28" height="28" /></> : <><img src="./assets/images/indicators/close.png" width="28" height="28" /></>
                                    }
                                  </td>
                                  <td className="text-center" >
                                    {
                                      item.ESTADO == 1 ? <>
                                        <img src="./assets/images/indicators/check.png" width="28" height="28" /></> : <><img src="./assets/images/indicators/close.png" width="28" height="28" /></>
                                    }
                                  </td>
                                  <td className="text-center">
                                    {
                                      evidencias.length != 0 ? <><img src="./assets/images/indicators/image.png" width="28" height="28" data-bs-toggle="modal" data-bs-target="#viewEvidencias" /></> : <><img src="./assets/images/indicators/clock.png" width="28" height="28" /></>
                                    }
                                  </td>
                                  <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO)}</td>


                                </tr>
                              ))
                            }

                          </tbody>
                          <tfoot>
                            <tr>
                              <td colSpan={5} className="text-end fw-bold">Subtotal:</td>
                              <td className="fw-bold text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subtotal_servicios)}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>

                    {/* Refacciones Instaladas */}
                    <h5 className="card-title fw-bold text-dark mb-1 mt-4">Refacciones Instaladas </h5>
                    <div className="row mb-3">
                      <div className="table-responsive mt-1 table-scrollbar-6">
                        <table className="table table-sm table-striped table-hover">
                          <thead>
                            <tr>
                              <th scope="col" className='th-sticky'>#</th>
                              <th scope="col" className='th-sticky'>REFACCIÓN</th>
                              <th scope="col" className="text-center th-sticky">ESTADO</th>
                              <th scope="col" className="text-center th-sticky">EVIDENCIAS</th>
                              <th scope="col" className="text-end th-sticky">COSTO ($)</th>
                              <th scope="col" className="text-end th-sticky">C. CLIENTE. ($)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              refacciones.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{item.REFACCION}</td>

                                  <td className="text-center">
                                    {item.ESTADO == 0 ? <> <span className="status-btn pending-btn"> Solicitada </span>  </> : <> </>}
                                    {item.ESTADO == 1 ? <> <span className="status-btn revision-btn"> Aprobada </span>  </> : <> </>}
                                    {item.ESTADO == 2 ? <> <span className="status-btn progress-btn"> Comprada, en espera </span>  </> : <> </>}
                                    {item.ESTADO == 3 ? <> <span className="status-btn tests-btn"> Llego </span>  </> : <> </>}
                                    {item.ESTADO == 4 ? <> <span className="status-btn vacaciones-btn"> Disponible </span>  </> : <> </>}
                                    {item.ESTADO == 5 ? <> <span className="status-btn complete-btn"> Instalada </span>  </> : <> </>}
                                    {item.ESTADO == 6 ? <> <span className="status-btn pending-btn"> Rechazo Cliente </span>  </> : <> </>}
                                  </td>
                                  <td className="text-center">
                                    {
                                      evidencias.length != 0 ? <><img src="./assets/images/indicators/image.png" width="28" height="28" data-bs-toggle="modal" data-bs-target="#viewEvidencias" /></> : <><img src="./assets/images/indicators/clock.png" width="28" height="28" /></>
                                    }
                                  </td>

                                  <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO_HDL)}</td>
                                  <td className="text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO_CLIENTE)}</td>
                                </tr>
                              ))
                            }

                          </tbody>
                          <tfoot>
                            <tr>
                              <td colSpan={5} className="text-end fw-bold">Subtotal:</td>
                              <td className="fw-bold text-end">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subtotal_refacciones)}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>

                    <div className='row'>
                      <div className='col-12'>
                        <div className="text-end">
                          <h5 className="">Subtotal de Servicios y Refacciones: <span
                            className="fw-bold">{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(subtotal)}</span> </h5>
                        </div>
                      </div>
                    </div>



                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }

  }

}
